export const ratings = ["S", "AA", "A", "NR"] as const;
export type Rating = typeof ratings[number];
